import React from 'react';
import {isBrowser} from '@utils/Browser';

const SSR = (props) => {
    return !isBrowser ? <div suppressHydrationWarning>{props.children}</div> :
        <div dangerouslySetInnerHTML={{__html: ''}} suppressHydrationWarning/>
};

export default SSR;
